import { useAuth0 } from "@auth0/auth0-react";

type Props = {
  className: string
}

const Logout = ({ className }: Props) => {
  const { logout } = useAuth0();

  return (
    <button onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })} className={className}>
      Log Out
    </button>
  );
};

export default Logout;